import {
    AppBar,
    Button,
    Icon,
    IconButton,
    Stack,
    Toolbar,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import usePageSize from "../../hooks/UsePageSize";
import { getAppBarItemsForSize } from "../../utils/menu";
import { clearLocalStorageKeepingPolicyNotices } from "../../utils/storage";
import AppBarMenuItem from "./AppBarMenuItem";
import UserMenu from "./UserMenu";

export default function CustomizedAppBar (props: { toggleDrawer: () => void, isImpersonated: boolean; }) {

    const size = usePageSize();
    const appBarItems = getAppBarItemsForSize(size);

    const navigate = useNavigate();

    const theme = useTheme();

    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
    const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));

    const handleExitImpersonation = () => {
        clearLocalStorageKeepingPolicyNotices();
        window.location.reload();
    };

    return (
        <AppBar position="fixed">
            <Toolbar>
                <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    width="100%"
                >
                    {isSmallScreen && (
                        <>
                            <IconButton onClick={props.toggleDrawer}>
                                <Icon fontSize="large">menu</Icon>
                            </IconButton>

                            <Typography>
                                <a
                                    href={process.env.REACT_APP_HOME_URL}
                                    style={{
                                        textDecoration: "none",
                                        color: theme.palette.text.primary,
                                    }}
                                    onClick={() => navigate("/")}
                                >
                                    پرشین سازه
                                </a>
                            </Typography>
                            {/*</a>*/}
                        </>
                    )}

                    {!isSmallScreen && (
                        <a
                            href={process.env.REACT_APP_HOME_URL}
                            style={{
                                height: "40px",
                                width: "40px",
                                cursor: "pointer",
                            }}
                            onClick={() => navigate("/")}
                        >
                            <img
                                width={40}
                                height={40}
                                src={
                                    theme.palette.mode === "dark"
                                        ? "./images/logo_dark.png"
                                        : "./images/logo_light.png"
                                }
                            />
                        </a>
                    )}

                    <Stack
                        direction="row"
                        spacing={2}
                        flexGrow={1}
                        sx={{ pl: 2 }}
                    >
                        {appBarItems.map((page) => (
                            <AppBarMenuItem key={page.url} menuItem={page} />
                        ))}
                    </Stack>

                    {
                        !props.isImpersonated ?
                            (<>
                                {!isMediumScreen && (
                                    <>
                                        <Link to="https://persiansaze.com/roadmap">
                                            <Button
                                                size="small"
                                                color="primary"
                                                variant="contained"
                                            >
                                                مسیر موفقیت
                                            </Button>
                                        </Link>

                                        <Link to="/subscriptions">
                                            <Button
                                                sx={{
                                                    display: {
                                                        md: "inline-block",
                                                        xs: "none",
                                                    },
                                                }}
                                                size="small"
                                                variant="contained"
                                                color="secondary"
                                            >
                                                مقایسه اشتراک ها
                                            </Button>
                                        </Link>
                                    </>
                                )}
                            </>) :
                            (<>
                                <Button size="small" variant="contained"
                                    onClick={handleExitImpersonation}
                                    color="warning">خروج از حساب </Button>
                            </>)
                    }


                    <UserMenu />
                </Stack>
            </Toolbar>
        </AppBar>
    );
}
